import FulfilmentsUtil from "../../utils/fulfilments-util";

const util = new FulfilmentsUtil();

export default {
  data() {
    return {
      deletedRowsStack: [],
    };
  },
  methods: {
    pruneEmptyGroups(items, removed = null) {
      if (!Array.isArray(items)) return;
      for (let i = items.length - 1; i >= 0; i--) {
        const item = items[i];
        if (Array.isArray(item.children)) {
          this.pruneEmptyGroups(item.children, removed);
        }
        const hasChildren = Array.isArray(item.children) && item.children.length > 0;
        const isEmptyGroup = Array.isArray(item.children) && item.children.length === 0 && item.isGrouped;
        if (!hasChildren && isEmptyGroup) {
          if (removed) {
            removed.push(item);
          }
          items.splice(i, 1);
        }
      }
    },

    findNodeLocation(id, items = this.deliverables) {
      if (!Array.isArray(items)) return null;
      for (let i = 0; i < items.length; i++) {
        const node = items[i];
        if (node.id === id) return { parentArray: items, index: i, node };
        if (node.children && node.children.length) {
          const res = this.findNodeLocation(id, node.children);
          if (res) return res;
        }
      }
      return null;
    },

    deleteRows() {
      if (this.selectedRows.length === 0) return;
      const deletedRows = [];
      const locations = this.selectedRows
        .map((id) => this.findNodeLocation(id))
        .filter((loc) => loc && loc.parentArray)
        .sort((a, b) => b.index - a.index);

      locations.forEach(({ parentArray, index, node }) => {
        if (!node) return;
        if (node.children && node.children.length > 0) {
          deletedRows.push(...node.children);
        }
        deletedRows.push(node);
        parentArray.splice(index, 1);
      });

      this.selectedRows = [];
      this.deletedRowsStack.push(deletedRows);

      this.pruneEmptyGroups(this.deliverables, deletedRows);
      util.recalculateAllFulfillments(this.deliverables, this.steps);
      this.syncParentIds && this.syncParentIds(this.deliverables);
      this.renumberDeliverables(this.deliverables);
      this.$store.dispatch("setDeliverables", this.deliverables);
      this.toolboxVisible = false;
      this.index = null;
    },

    deleteChildRow(id, deletedRows) {
      this.deliverables.forEach((parent, parentIndex) => {
        const childIdx = parent.children ? parent.children.findIndex((child) => child.id === id) : -1;
        if (childIdx !== -1) {
          const deletedChild = parent.children.splice(childIdx, 1)[0];
          deletedRows.push(deletedChild);
          if (parent.children.length === 0) {
            this.deliverables.splice(parentIndex, 1);
            deletedRows.push(parent);
          }
        }
      });
    },

    undoDelete() {
      if (this.deletedRowsStack.length === 0) return;

      const lastDeletedRows = this.deletedRowsStack.pop();

      lastDeletedRows.forEach((row) => {
        if (row.parentId) {
          const parentLoc = this.findNodeLocation(row.parentId);
          const parent = parentLoc ? parentLoc.node : null;
          if (parent) {
            parent.children = parent.children || [];
            parent.children.push(row);
            parent.children.sort((a, b) => a.id - b.id);
          } else {
            this.deliverables.push(row);
          }
        } else {
          const existingRow = this.deliverables.find((d) => d.id === row.id);
          if (existingRow) {
            row.id = this.getNextAvailableId(this.deliverables);
          }
          this.deliverables.push(row);
        }
      });

      util.recalculateAllFulfillments(this.deliverables, this.steps);
      this.syncParentIds && this.syncParentIds(this.deliverables);
      this.renumberDeliverables(this.deliverables);
      this.$store.dispatch("setDeliverables", this.deliverables);
    },

    getNextAvailableId(deliverables) {
      let id = 1;
      let tasksLength = deliverables.length;
      if (tasksLength !== 0) {
        id = this.deliverables[tasksLength - 1].id + 1;
      }
      return id;
    },

    recalculateNumbering() {
      this.renumberDeliverables(this.deliverables);
    },

    renumberDeliverables(deliverables) {
      const renumberRecursive = (items, prefix = "") => {
        if (!Array.isArray(items)) return;
        items.forEach((item, idx) => {
          const currentId = prefix ? `${prefix}.${idx + 1}` : idx + 1;
          item.id = currentId;
          if (Array.isArray(item.children) && item.children.length > 0) {
            renumberRecursive(item.children, String(currentId));
          }
        });
      };
      renumberRecursive(deliverables);
      return deliverables;
    },

    syncParentIds(items, parentId = undefined) {
      if (!Array.isArray(items)) return;
      items.forEach((item) => {
        const hasChildren = Array.isArray(item.children) && item.children.length > 0;
        item.parentId = parentId;
        item.isGrouped = hasChildren;
        item.isChild = hasChildren;
        if (hasChildren) {
          this.syncParentIds(item.children, item.id);
        }
      });
    },
  },
};
